import { DotNavigationButton } from 'components/Button';
import { LegacyButton } from 'components/Button/LegacyButton';
import { CarouselState } from 'components/Carousel';
import { Icon } from 'components/Icon';
import { range } from 'utils/functional/array/range';

import {
  CmsThreeSectionSliderBlockCarouselNavigationDots,
  CmsThreeSectionSliderBlockCarouselNavigationHolder,
} from './CmsThreeSectionSliderBlockCarouselNavigation.styled';

type Props = {
  carouselState: CarouselState;
};

export function CmsThreeSectionSliderBlockCarouselNavigation({
  carouselState,
}: Props) {
  const { currentPage, pageCount, goToNextPage, goToPreviousPage, goToPage } =
    carouselState;

  const title = {
    prev: getText('Previous page'),
    next: getText('Next page'),
  };
  const prevDisabled = currentPage <= 0;
  const nextDisabled = currentPage >= pageCount - 1;

  if (pageCount === 0) return null;

  return (
    <nav>
      <CmsThreeSectionSliderBlockCarouselNavigationHolder>
        <LegacyButton
          onClick={goToPreviousPage}
          aria-label={title.prev}
          title={title.prev}
          disabled={prevDisabled}
          data-qa-id="carousel-left-button"
        >
          <Icon name="chevron-left" size={24} />
        </LegacyButton>

        <LegacyButton
          onClick={goToNextPage}
          aria-label={title.next}
          title={title.next}
          disabled={nextDisabled}
          data-qa-id="carousel-right-button"
        >
          <Icon name="chevron-right" size={24} />
        </LegacyButton>
      </CmsThreeSectionSliderBlockCarouselNavigationHolder>

      <CmsThreeSectionSliderBlockCarouselNavigationDots>
        {range(pageCount).map((index) => (
          <DotNavigationButton
            key={index}
            onClick={() => goToPage(index)}
            $isActive={index === currentPage}
            title={`${getText('Go to page')} ${index + 1}`}
          />
        ))}
      </CmsThreeSectionSliderBlockCarouselNavigationDots>
    </nav>
  );
}
